import { render, staticRenderFns } from "./wechatChannelMonthlyReport.vue?vue&type=template&id=754fab78&scoped=true&"
import script from "./wechatChannelMonthlyReport.vue?vue&type=script&lang=js&"
export * from "./wechatChannelMonthlyReport.vue?vue&type=script&lang=js&"
import style0 from "./wechatChannelMonthlyReport.vue?vue&type=style&index=0&id=754fab78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754fab78",
  null
  
)

export default component.exports